export default __webpack_public_path__ + "static/media/Shop2GoImg.7d5d84eb.jpg";